/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scopeAccessSelectorRoleWizard.vue?vue&type=template&id=4c8541ea&"
import script from "./scopeAccessSelectorRoleWizard.vue?vue&type=script&lang=js&"
export * from "./scopeAccessSelectorRoleWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCardText,VForm})
